import { IElement } from "processEditor/model/IProcessData";
import { Triggers } from "processEditor/model/ITriggerData";
import { ValidationError, ValidationErrorType } from "processEditor/model/ValidationData";

export default function ({ triggers, validationErrors }: ITriggerValidatorProps) {
    const conditionalTriggers = triggers.filter((e) => e?.selectedTypeId === Triggers.ConditionalTrigger.triggerType);
    for (const trigger of conditionalTriggers) {
        const hasSelectedProcessGuid = !!trigger?.parameters?.processGuid;

        if (hasSelectedProcessGuid) {
            continue;
        }

        validationErrors.push(new ValidationError(ValidationErrorType.SubprocessSelectionMissing, trigger?.id, "subprocess"));
    }
}

export interface ITriggerValidatorProps {
    triggers: IElement[];
    validationErrors: ValidationError[];
}